import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllChecklistServicoEmpreendimentoUseCase } from "../../../presentation/useCases/read/get_all_checklist_servico_empreendimento_use_case";
import { ChecklistServicoEmpreendimento } from "../../models/checklist_servico_empreendimento_lista";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

export class GetAllChecklistServicoEmpreendimentoUseCase extends BasePaginatedUseCase<ChecklistServicoEmpreendimento>
    implements IGetAllChecklistServicoEmpreendimentoUseCase {
    constructor(private readonly repository: IIncorporacaoRepository) { super(); }

    async getAllChecklistServicoEmpreendimento(
        idEmpreendimento?: number,
        idsChecklistServico?: number[],
        idsBloco?: number[],
        idsUnidade?: number[],
        idsItemServicoEmpreendimento?: number[],

        page?: number,
        rowsPerPage?: number
    ): Promise<void> {
        const response = await this.repository.getAllChecklistServicoEmpreendimento(
            idEmpreendimento,
            idsChecklistServico,
            idsBloco,
            idsUnidade,
            idsItemServicoEmpreendimento,
            page,
            rowsPerPage,
        );

        this._items = response.items;
        this._pageSize = response.pageSize;
        this._currentPage = response.currentPage;
        this._totalItems = response.totalItems;
        this._totalPages = response.totalPages;
    }
}